// reducer.js
import {
  CANDIDATE_SAVE_FOR_LATER_REQUEST,
  CANDIDATE_SAVE_FOR_LATER_SUCCESS,
  CANDIDATE_SAVE_FOR_LATER_FAILURE,
  CANDIDATE_SAVE_FOR_LATER_RESET,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  status: false,
  message: "",
};

const candidateSaveForLaterReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_SAVE_FOR_LATER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CANDIDATE_SAVE_FOR_LATER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case CANDIDATE_SAVE_FOR_LATER_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };

    case CANDIDATE_SAVE_FOR_LATER_RESET:
      return {
        ...state,
        isLoading: false,
        status: false,
        message: "",
      };
    default:
      return state;
  }
};

export default candidateSaveForLaterReducer;
